import useReplaceProposal from '@/api/mutations/proposals/useReplaceProposal';
import ProposalConfirmationModal from '@/ui/pages/proposalBuilderPage/components/proposalLifecycleActions/ProposalConfirmationModal';
import { ModalProps, Text, useToastContext } from '@payaca/ambrosia';
import { FC } from 'react';

type EditSentProposalModalProps = {
  proposalId: string;
  projectId: string;
  /** Called with the editable copy's public id, to navigate to its builder. */
  onReplaced: (replacementProposalId: string) => void;
} & Omit<ModalProps, 'title'>;

const EditSentProposalModal: FC<EditSentProposalModalProps> = (props) => {
  const { proposalId, projectId, onReplaced, onClose, ...rest } = props;
  const { pushSuccess } = useToastContext();

  const { mutate, isPending } = useReplaceProposal({
    proposalId,
    projectId,
    options: {
      onSuccess: (data) => {
        pushSuccess('Proposal reopened for editing.');
        onClose?.();
        onReplaced(data.replaceProposal.publicId);
      },
    },
  });

  return (
    <ProposalConfirmationModal
      {...rest}
      onClose={onClose}
      title="Edit proposal"
      confirmLabel="Edit proposal"
      isPending={isPending}
      onConfirm={() => mutate({ proposalId })}
    >
      <Text>
        Editing creates a new version of this proposal. The link the customer
        already has will stop working, and they get a fresh one when you send
        the new version.
      </Text>
    </ProposalConfirmationModal>
  );
};

export default EditSentProposalModal;
